document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.logos-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 18,
    clickable: true,
    watchOverflow: true, // No activa Swiper si caben todos los slides
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      769: { // Desktop
        slidesPerView: 'auto',
        spaceBetween: 20
      }
    }
  });

  const swiper = new Swiper('.value-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 9,
    watchOverflow: true,
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },

  
  });

 const sliderCollection = new Swiper('.slider-collections-swiper', {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 10,
    watchOverflow: true,
    loop: false,
    navigation: {
      nextEl: `.swiper-button-next-collection-slider`,
      prevEl: `.swiper-button-prev-collection-slider`,
    },
    pagination: {
      el: `.slider-collections-swiper-pagination`,
      clickable: true,
    },
    breakpoints: {
      750: {
        slidesPerView: 4,
      }
    },
  });


  const sliderUgc = new Swiper('.video-ugc-swiper', {
    slidesPerView: 'auto',
    // slidesPerGroup: 2,
    spaceBetween: 15,
    watchOverflow: true,
    loop: false,
    navigation: {
      nextEl: `.swiper-button-next-video-ugc`,
      prevEl: `.swiper-button-video-ugc`,
    },
    pagination: {
      el: `.video-ugc-swiper-pagination`,
      clickable: true,
    },
    breakpoints: {
      750: {
        slidesPerView: 'auto'
      }
    },
  });


});

